import { useEffect, useRef } from "react";
import { StationOrderModel } from "../../data/models/product/ProductModel";

export const useStationOrderSounds = (orders: StationOrderModel[]) => {
  const prevOrders = useRef<StationOrderModel[]>([]);

  useEffect(() => {
    if (!orders || orders.length === 0) {
      prevOrders.current = [];
      return;
    }

    if (prevOrders.current.length > 0) {
      const newOrders = orders.filter(
        (o) => !prevOrders.current.some((p) => p.orderId === o.orderId)
      );

      if (newOrders.length > 0) {
        playSound();
      }
    }

    orders.forEach((order) => {
      const prev = prevOrders.current.find((o) => o.orderId === order.orderId);
      if (!prev) return;

      if (JSON.stringify(prev.items) !== JSON.stringify(order.items)) {
        playSound();
      }
    });

    prevOrders.current = orders;
  }, [orders]);
};

const playSound = () => {
  const audio = new Audio("/assets/sound-station.mp3");
  audio.play().catch(() => {});
};
